export { default as miniIconsRegistration } from './data/miniCommonIconsRegistration';
export { default as MiniIcons } from './data/MiniCommonIcons';
export { default as getCustomIcon, getCustomIconName } from './utils/getCustomIcon';
